export const getTagsWithPlatformTag = (tags?: string[]): string[] => {
	const defaultTags = ['atlaskit'];
	if (!tags) {
		return defaultTags;
	}
	return defaultTags.concat(tags);
};
